import {HTTP} from "@/plugins/axios";
import ProductType from "@/enums/ProductType";

const brands = {
    namespaced: true,
    state: {
        brands: {},
    },
    mutations: {
        SET_BRANDS (state, value) { state.brands = value },
    },
    actions: {
        GET_ALL_BRANDS({commit}) {
            return new Promise((resolve, reject) => {
                HTTP.get(`/ClientSide/Get?start=0&end=10&objectName=${ProductType.Brand}`)
                    .then((response) => {
                        commit('SET_BRANDS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_BRANDS', {})
                        reject(error)
                    });
            })
        },
    },
    getters : {
        brands: state => state.brands,
    }
}

export default brands;